const metaRoutes = [
  {
    path: "/crm/leads",
    title: "Leads",
    name: "lead",
    secondKey: "view",
  },
  {
    path: "/crm/leads/create",
    title: "Create lead",
    name: "lead",
    secondKey: "edit",
  },
  {
    path: "/crm/leads/edit/[id]",
    title: "Edit lead",
    name: "lead",
    secondKey: "edit",
  },
  {
    path: "/crm/leads/view/[id]",
    title: "Lead details",
    name: "lead",
    secondKey: "view",
  },
  {
    path: "/crm/settings",
    title: "Settings",
    name: "settings",
    secondKey: "view",
  },
  {
    path: "/crm/settings/roles-and-permissions",
    title: "Roles and permissions",
    name: "settings",
    secondKey: "rolesAndPermissions",
  },
  {
    path: "/crm/settings/lead-nurturing/lead-status",
    title: "Lead statuses",
    name: "settings",
    secondKey: "leadStatus",
  },
  {
    path: "/crm/settings/lead-nurturing/lead-scoring",
    title: "Lead Scoring",
    name: "settings",
    secondKey: "leadScoring",
  },
  {
    path: "/switchcompany",
    title: "Switch companies",
  },
  {
    path: "/crm",
    title: "CRM",
  },
  {
    path: "/crm/settings/integrations/appointment-scheduling",
    title: "Appointment Scheduling",
  },
  {
    path: "/crm/settings/email-settings/general",
    title: "Email Settings - General",
  },
  {
    path: "/crm/settings/email-settings/advance",
    title: "Email Settings - Advance",
  },
  {
    path: "/crm/settings/lead-nurturing/lead-source",
    title: "Lead Source",
    name: "settings",
    secondKey: "leadSource",
  },
  {
    path: "/crm/settings/lead-nurturing/custom-fields",
    title: "Custom Fields",
    name: "settings",
    secondKey: "customField",
  },
  {
    path: "/crm/settings/communication-templates/sms-templates",
    title: "SMS Templates",
    name: "settings",
    secondKey: "smsTemplate",
  },
  {
    path: "/crm/settings/communication-templates/email-templates",
    title: "Email Templates",
    name: "settings",
    secondKey: "emailTemplate",
  },
  {
    path: "/crm/settings/communication-templates/email-signature",
    title: "Email Signature",
    name: "settings",
    secondKey: "emailSignature",
  },
  {
    path: "/crm/settings/user-profile",
    title: "User Profile",
    name: "settings",
    secondKey: "userProfile",
  },
  {
    path: "/crm/settings/media-storage",
    title: "Email Settings - Media Storage",
    name: "settings",
    secondKey: "mediaStorage",
  },
  {
    path: "/crm/analytics/dashboard",
    title: "Dashboard",
    name: "analytics",
    secondKey: "dashboard",
  },
  {
    path: "/crm/analytics/reports",
    title: "Reports",
    name: "analytics",
    secondKey: "reports",
  },
  {
    path: "/crm/leads/list",
    title: "Lists",
    name: "list",
    secondKey: "view",
  },
  {
    path: "/crm/leads/list/create/[id]",
    title: "Lists",
    name: "list",
    secondKey: "edit",
  },
  {
    path: "/crm/leads/list/edit/[id]",
    title: "Lists",
    name: "list",
    secondKey: "edit",
  },
  {
    path: "/crm/automation/automations",
    title: "Automations",
    name: "automation",
    secondKey: "automations",
  },
  {
    path: "/crm/automation/templates",
    title: "Templates",
    name: "automation",
    secondKey: "template",
  },
  {
    path: "/crm/settings/roles-and-permissions",
    title: "Communication Permissions",
    name: "communicationPermissions",
    secondKey: "communicationPermissions",
  },
];

export default metaRoutes;
